import { render, staticRenderFns } from "./DocumentTab.vue?vue&type=template&id=79616f72&"
import script from "./DocumentTab.vue?vue&type=script&lang=js&"
export * from "./DocumentTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports